import type { ResultKind } from '../logic/constants'

export function SearchIcon({ className }: { className?: string }) {
  return (
    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" className={className}>
      <circle cx="6" cy="6" r="4.5" stroke="currentColor" strokeWidth="1.5" />
      <path d="M9.5 9.5 13 13" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
    </svg>
  )
}

export function ArrowRightIcon({ className }: { className?: string }) {
  return (
    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" className={className}>
      <path
        d="M3 7h7M7 3.5 10.5 7 7 10.5"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export function ChevronDownIcon({ className }: { className?: string }) {
  return (
    <svg width="12" height="12" viewBox="0 0 12 12" fill="none" className={className}>
      <path
        d="M3 4.5 6 7.5 9 4.5"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export function EntityIcon({ kind, className }: { kind: ResultKind; className?: string }) {
  const shared = {
    stroke: 'currentColor',
    strokeWidth: 1.5,
    strokeLinecap: 'round' as const,
    strokeLinejoin: 'round' as const,
  }

  if (kind === 'pages') {
    return (
      <svg width="12" height="12" viewBox="0 0 12 12" fill="none" className={className}>
        <path d="M3 2.5h6M3 5h6M3 7.5h4" {...shared} />
        <path d="M1.75 2.5h.01M1.75 5h.01M1.75 7.5h.01" {...shared} />
      </svg>
    )
  }

  if (kind === 'views') {
    return (
      <svg width="12" height="12" viewBox="0 0 12 12" fill="none" className={className}>
        <path d="M1.5 6s1.6-3 4.5-3 4.5 3 4.5 3-1.6 3-4.5 3-4.5-3-4.5-3Z" {...shared} />
        <circle cx="6" cy="6" r="1.25" {...shared} />
      </svg>
    )
  }

  if (kind === 'fields') {
    return (
      <svg width="12" height="12" viewBox="0 0 12 12" fill="none" className={className}>
        <rect x="2" y="2.25" width="8" height="7.5" rx="1" {...shared} />
        <path d="M4.7 2.25v7.5M7.3 2.25v7.5" {...shared} />
      </svg>
    )
  }

  if (kind === 'values') {
    return (
      <svg width="12" height="12" viewBox="0 0 12 12" fill="none" className={className}>
        <path d="M2 3h5.5M2 6h8M2 9h4.5" {...shared} />
        <path d="M9 2.5 10.25 3.75 9 5" {...shared} />
      </svg>
    )
  }

  return (
    <svg width="12" height="12" viewBox="0 0 12 12" fill="none" className={className}>
      <rect x="2" y="2" width="8" height="8" rx="1.25" {...shared} />
      <path d="M2 4.75h8M4.5 2v8" {...shared} />
    </svg>
  )
}

export function FooterKey({ label }: { label: string }) {
  return (
    <span className="border-default inline-flex h-4 min-w-4 items-center justify-center rounded border bg-[color:var(--bg-muted)] px-1 font-sans text-[9px] font-medium leading-none text-muted">
      {label}
    </span>
  )
}
